"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var handleChange = function handleChange(onChange) {
  return function (ev) {
    if (onChange) {
      onChange(Number(ev.target.value));
    }
  };
};

var NumberInput = function NumberInput(_a) {
  var id = _a.id,
      onChange = _a.onChange,
      value = _a.value,
      label = _a.label,
      className = _a.className,
      inputClassName = _a.inputClassName,
      subText = _a.subText,
      props = __rest(_a, ["id", "onChange", "value", "label", "className", "inputClassName", "subText"]);

  return react_1.default.createElement("div", {
    className: classnames_1.default('form-group', className)
  }, label && react_1.default.createElement("label", {
    htmlFor: id
  }, label), react_1.default.createElement("input", __assign({
    id: id,
    type: 'number',
    value: value,
    onChange: handleChange(function (n) {
      return onChange && onChange(n);
    }),
    className: classnames_1.default('form-control', className)
  }, props)), subText && react_1.default.createElement("small", {
    className: 'form-text text-muted'
  }, subText));
};

exports.default = NumberInput;